import { defineMessages } from 'react-intl';

export const CHATBOT_CONTACT_PATHS = {
  ca: '/ca/contact-form',
  es: '/es/contact-form',
  en: '/en/contact-form',
};

export const chatbotMessages = defineMessages({
  chatbotEyebrow: {
    id: 'chatbot.eyebrow',
    defaultMessage: 'Chatbot IA',
  },
  defaultChatbotTitle: {
    id: 'chatbot.defaultTitle',
    defaultMessage: "Assistent d'Iskra",
  },
  defaultChatbotPlaceholder: {
    id: 'chatbot.defaultPlaceholder',
    defaultMessage: 'En què et podem ajudar?',
  },
  defaultChatbotFollowUpPlaceholder: {
    id: 'chatbot.defaultFollowUpPlaceholder',
    defaultMessage: 'Fes una repregunta…',
  },
  defaultChatbotPromptsHeading: {
    id: 'chatbot.defaultPromptsHeading',
    defaultMessage: 'Preguntes freqüents',
  },
  defaultChatbotPromptAiServices: {
    id: 'chatbot.defaultPromptAiServices',
    defaultMessage: 'Com podem aplicar IA al nostre negoci?',
  },
  defaultChatbotPromptContact: {
    id: 'chatbot.defaultPromptContact',
    defaultMessage: "Podeu integrar agents d'IA amb els nostres sistemes?",
  },
  defaultChatbotPromptTechnologies: {
    id: 'chatbot.defaultPromptTechnologies',
    defaultMessage: 'Quines automatitzacions tenen més impacte?',
  },
  defaultChatbotPromptTeam: {
    id: 'chatbot.defaultPromptTeam',
    defaultMessage: "Vull parlar amb l'equip →",
  },
  defaultHomeTitle: {
    id: 'chatbot.defaultHomeTitle',
    defaultMessage: 'Com et podem ajudar?',
  },
  defaultHomeDescription: {
    id: 'chatbot.defaultHomeDescription',
    defaultMessage:
      "Vols explorar com aplicar IA al teu negoci, automatitzar processos o construir nous productes intel·ligents? Explica'ns què estàs construint.",
  },
  defaultHomePlaceholder: {
    id: 'chatbot.defaultHomePlaceholder',
    defaultMessage: 'Escriu la teva consulta aquí...',
  },
  submit: {
    id: 'chatbot.submit',
    defaultMessage: 'Enviar',
  },
  defaultHeaderDescription: {
    id: 'chatbot.defaultHeaderDescription',
    defaultMessage:
      "Vols explorar com aplicar IA al teu negoci, automatitzar processos o construir nous productes intel·ligents? Escriu-nos a {email}.",
  },
  answerTab: {
    id: 'chatbot.answerTab',
    defaultMessage: 'Resposta',
  },
  documentLabel: {
    id: 'chatbot.documentLabel',
    defaultMessage: 'Document {index}:',
  },
  introMessage: {
    id: 'chatbot.introMessage',
    defaultMessage: "Explica'ns què estàs construint.",
  },
  fileIconAlt: {
    id: 'chatbot.fileIconAlt',
    defaultMessage: 'Icona de fitxer',
  },
  findingRelatedQuestions: {
    id: 'chatbot.findingRelatedQuestions',
    defaultMessage: 'Buscant preguntes relacionades...',
  },
  newConversation: {
    id: 'chatbot.newConversation',
    defaultMessage: 'Nova conversa',
  },
  close: {
    id: 'chatbot.close',
    defaultMessage: 'Tanca',
  },
  loadingAssistant: {
    id: 'chatbot.loadingAssistant',
    defaultMessage: "Carregant l'assistent…",
  },
  loadAssistantError: {
    id: 'chatbot.loadAssistantError',
    defaultMessage: "No s'ha pogut carregar la configuració del chatbot.",
  },
  contactUs: {
    id: 'chatbot.contactUs',
    defaultMessage: 'Contacta amb nosaltres',
  },
  seeAllSources: {
    id: 'chatbot.seeAllSources',
    defaultMessage: 'Veure totes les fonts',
  },
  moderationMessage: {
    id: 'chatbot.moderationMessage',
    defaultMessage: 'No puc processar aquesta petició. Si necessites ajuda personalitzada, escriu-nos a {email} o visita {contactPath}.',
  },
  rateLimitMessage: {
    id: 'chatbot.rateLimitMessage',
    defaultMessage: "Has superat el límit temporal del chatbot ({limit} peticions per minut). Torna-ho a provar d'aquí a una estona.",
  },
  unavailableMessage: {
    id: 'chatbot.unavailableMessage',
    defaultMessage: 'El chatbot està desactivat en aquesta compilació.',
  },
  suggestionsLabel: {
    id: 'chatbot.suggestionsLabel',
    defaultMessage: 'Prova amb:',
  },
  sourceLabel: {
    id: 'chatbot.sourceLabel',
    defaultMessage: 'Font',
  },
  sourceTypeFile: {
    id: 'chatbot.sourceTypeFile',
    defaultMessage: 'Fitxer',
  },
  sourceTypeWebsite: {
    id: 'chatbot.sourceTypeWebsite',
    defaultMessage: 'Web',
  },
  sourceWithoutLink: {
    id: 'chatbot.sourceWithoutLink',
    defaultMessage: 'Aquest document no té cap enllaç.',
  },
  sourcesTab: {
    id: 'chatbot.sourcesTab',
    defaultMessage: 'Fonts',
  },
  editModeWarning: {
    id: 'chatbot.editModeWarning',
    defaultMessage: 'El chatbot està desactivat via RAZZLE_CHATBOT_ENABLED. El bloc només és visible en mode edició fins que s’activi a la compilació.',
  },
  feedbackReasonRepetitive: {
    id: 'chatbot.feedbackReasonRepetitive',
    defaultMessage: 'Repetitiva',
  },
  feedbackReasonIrrelevant: {
    id: 'chatbot.feedbackReasonIrrelevant',
    defaultMessage: 'Irrellevant',
  },
  feedbackReasonInaccurate: {
    id: 'chatbot.feedbackReasonInaccurate',
    defaultMessage: 'Inexacta o incompleta',
  },
  feedbackReasonUnclear: {
    id: 'chatbot.feedbackReasonUnclear',
    defaultMessage: 'Poc clara',
  },
  feedbackReasonSlow: {
    id: 'chatbot.feedbackReasonSlow',
    defaultMessage: 'Lenta',
  },
  feedbackReasonWrongSources: {
    id: 'chatbot.feedbackReasonWrongSources',
    defaultMessage: 'Fonts incorrectes',
  },
  feedbackReasonTooLong: {
    id: 'chatbot.feedbackReasonTooLong',
    defaultMessage: 'Massa llarga',
  },
  feedbackReasonTooShort: {
    id: 'chatbot.feedbackReasonTooShort',
    defaultMessage: 'Massa curta',
  },
  feedbackReasonOutdatedSources: {
    id: 'chatbot.feedbackReasonOutdatedSources',
    defaultMessage: 'Fonts desactualitzades',
  },
  feedbackReasonTooManyFollowUpQuestions: {
    id: 'chatbot.feedbackReasonTooManyFollowUpQuestions',
    defaultMessage: 'Calen massa repreguntes',
  },
  toolCallSearchPrefix: {
    id: 'chatbot.toolCallSearchPrefix',
    defaultMessage: 'S’ha cercat:',
  },
  untitledDocument: {
    id: 'chatbot.untitledDocument',
    defaultMessage: 'document sense títol',
  },
  updatedLabel: {
    id: 'chatbot.updatedLabel',
    defaultMessage: 'Actualitzat',
  },
  webIconAlt: {
    id: 'chatbot.webIconAlt',
    defaultMessage: 'Icona web',
  },
});

export const chatbotPromptMessages = [chatbotMessages.defaultChatbotPromptAiServices, chatbotMessages.defaultChatbotPromptContact, chatbotMessages.defaultChatbotPromptTechnologies, chatbotMessages.defaultChatbotPromptTeam];

export const chatbotFeedbackReasonMessages = [chatbotMessages.feedbackReasonRepetitive, chatbotMessages.feedbackReasonIrrelevant, chatbotMessages.feedbackReasonInaccurate, chatbotMessages.feedbackReasonUnclear, chatbotMessages.feedbackReasonSlow, chatbotMessages.feedbackReasonWrongSources, chatbotMessages.feedbackReasonTooLong, chatbotMessages.feedbackReasonTooShort, chatbotMessages.feedbackReasonOutdatedSources, chatbotMessages.feedbackReasonTooManyFollowUpQuestions];
